import { createGlobalStyle } from 'styled-components';
import styledNormalize from 'styled-normalize';
// import {config} from '../index';

import simplonRegularEOT from '../../assets/fonts/simplonbp-regular-webfont.eot';
import simplonRegularWOFF from '../../assets/fonts/simplonbp-regular-webfont.woff';
import simplonRegularTTF from '../../assets/fonts/simplonbp-regular-webfont.ttf';
import simplonRegularSVG from '../../assets/fonts/simplonbp-regular-webfont.svg';

import simplonBoldEOT from '../../assets/fonts/simplonbp-bold-webfont.eot';
import simplonBoldWOFF from '../../assets/fonts/simplonbp-bold-webfont.woff';
import simplonBoldTTF from '../../assets/fonts/simplonbp-bold-webfont.ttf';
import simplonBoldSVG from '../../assets/fonts/simplonbp-bold-webfont.svg';

import simplonLightEOT from '../../assets/fonts/simplonbp-light-webfont.eot';
import simplonLightWOFF from '../../assets/fonts/simplonbp-light-webfont.woff';
import simplonLightTTF from '../../assets/fonts/simplonbp-light-webfont.ttf';
import simplonLightSVG from '../../assets/fonts/simplonbp-light-webfont.svg';

import simplonMediumEOT from '../../assets/fonts/simplonbp-medium-webfont.eot';
import simplonMediumWOFF from '../../assets/fonts/simplonbp-medium-webfont.woff';
import simplonMediumTTF from '../../assets/fonts/simplonbp-medium-webfont.ttf';
import simplonMediumSVG from '../../assets/fonts/simplonbp-medium-webfont.svg';

import simplonHeadlineEOT from '../../assets/fonts/simplonoi-headline-webfont.eot';
import simplonHeadlineWOFF from '../../assets/fonts/simplonoi-headline-webfont.woff';
import simplonHeadlineTTF from '../../assets/fonts/simplonoi-headline-webfont.ttf';
import simplonHeadlineSVG from '../../assets/fonts/simplonoi-headline-webfont.svg';

// const publicPath = config.get('publicPath');

export default createGlobalStyle`
  ${styledNormalize};
  @font-face {
    font-family: 'SimplonHeadline';
    src:
    url(${simplonHeadlineEOT});
    src:
    url(${`${simplonHeadlineEOT}?#iefix`}) format('embedded-opentype'),
    url(${simplonHeadlineWOFF}) format('woff'),
    url(${simplonHeadlineTTF}) format('truetype'),
    url(${simplonHeadlineSVG}) format('svg');
    font-weight: 400;
    font-style: normal;
  }
    @font-face {
    font-family: 'Simplon';
    src:
    url(${simplonLightEOT});
    src:
    url(${`${simplonLightEOT}?#iefix`}) format('embedded-opentype'),
    url(${simplonLightWOFF}) format('woff'),
    url(${simplonLightTTF}) format('truetype'),
    url(${simplonLightSVG}) format('svg');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'Simplon';
    src:
    url(${simplonRegularEOT});
    src:
    url(${`${simplonRegularEOT}?#iefix`}) format('embedded-opentype'),
    url(${simplonRegularWOFF}) format('woff'),
    url(${simplonRegularTTF}) format('truetype'),
    url(${simplonRegularSVG}) format('svg');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Simplon';
    src:
    url(${simplonBoldEOT});
    src:
    url(${`${simplonBoldEOT}?#iefix`}) format('embedded-opentype'),
    url(${simplonBoldWOFF}) format('woff'),
    url(${simplonBoldTTF}) format('truetype'),
    url(${simplonBoldSVG}) format('svg');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'Simplon';
    src:
    url(${simplonMediumEOT});
    src:
    url(${`${simplonMediumEOT}?#iefix`}) format('embedded-opentype'),
    url(${simplonMediumWOFF}) format('woff'),
    url(${simplonMediumTTF}) format('truetype'),
    url(${simplonMediumSVG}) format('svg');
    font-weight: 600;
    font-style: normal;
  }
  * {
    box-sizing: border-box;
  }
  html {
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    font-variant-ligatures: none;
    -webkit-font-variant-ligatures: none;
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;
    background: #f8f8f8;
    font-family: 'Simplon';
  }
  #application{
    opacity: 1;
  }
  :disabled {
    cursor: no-drop;
  }
  pre {
    margin: 20px auto;
  }
  .MuiCheckbox-colorSecondary.Mui-checked {
	color: #c2cd06 !important;
  }
  .MuiIconButton-colorSecondary {
	color: #c2cd06 !important;
  }
  .MuiFormLabel-root.Mui-focused {
    color: #828a00 !important;
  }
  .WithStyles\(ForwardRef\(Select\)\)-select-67:focus {
	color: #c2cd06 !important;
  }
  .MuiPickersDay-daySelected {
	background-color: #212322 !important;
  }
  .MuiPickersDay-current {
    color: #212322 !important;
  }
  .btnUploadDocumento {
    position: relative !important;
    display: -webkit-box !important;
    display: -webkit-flex !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -webkit-box-pack: center !important;
    -webkit-justify-content: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
    -webkit-align-content: center !important;
    -ms-flex-line-pack: center !important;
    align-content: center !important;
    -webkit-align-items: center !important;
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
    margin: 0 !important;
    padding: 15px 50px !important;
    width: 100% !important;
    min-width: initial !important;
    max-width: initial !important;
    height: initial !important;
    min-height: initial !important;
    max-height: initial !important;
    border: 0 !important;
    border-radius: 4px !important;
    font-family: Simplon,OiTextRegular,simplon_bpregular,sans-serif !important;
    font-weight: 400 !important;
    font-size: 1rem !important;
    text-transform: none !important;
    -webkit-text-decoration: none !important;
    text-decoration: none !important;
    -webkit-transition: all 0.2s ease-in-out !important;
    transition: all 0.2s ease-in-out !important;
    cursor: pointer !important;
    box-sizing: border-box !important;
    overflow: none !important;
    outline: 0 !important;
    border: 1px solid #fff !important;
    color: #222 !important;
    background-color: #F1FF00 !important;
    border-color: #fff !important;
    overflow: hidden;
    white-space: nowrap;
    margin-top: 16px !important;
  }
  .btnLimparFiltros {
    position: relative !important;
    display: -webkit-box !important;
    display: -webkit-flex !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -webkit-box-pack: center !important;
    -webkit-justify-content: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
    -webkit-align-content: center !important;
    -ms-flex-line-pack: center !important;
    align-content: center !important;
    -webkit-align-items: center !important;
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
    margin: 0 !important;
    padding: 15px 50px !important;
    width: initial !important;
    min-width: initial !important;
    max-width: initial !important;
    height: initial !important;
    min-height: initial !important;
    max-height: initial !important;
    border: 0 !important;
    border-radius: 4px !important;
    font-family: Simplon,OiTextRegular,simplon_bpregular,sans-serif !important;
    font-weight: 400 !important;
    font-size: 1rem !important;
    text-transform: none !important;
    -webkit-text-decoration: none !important;
    text-decoration: none !important;
    -webkit-transition: all 0.2s ease-in-out !important;
    transition: all 0.2s ease-in-out !important;
    cursor: pointer !important;
    box-sizing: border-box !important;
    overflow: none !important;
    outline: 0 !important;
    float: right;
    border: 1px solid #fff !important;
    color: #222 !important;
    background-color: #F1FF00 !important;
    border-color: #fff !important;
  }
  .css-189oyde-control {
	border-color: #c2cd06 !important;
  }
  .css-189oyde-control:hover {
	border-color: #c2cd06 !important;
  }
  .css-1f303uq-control {
	border-color: #c2cd06 !important;
  }
  .css-1f303uq-control:hover {
	border-color: #c2cd06 !important;
  }
  .css-11ea5pp-control {
	border-color: #c2cd06 !important;
  }
  .css-11ea5pp-control:hover {
	border-color: #c2cd06 !important;
  }
  .css-obd9gt-control {
	border-color: #c2cd06 !important;
  }
  .css-obd9gt-control:hover {
	border-color: #c2cd06 !important;
  }
  .css-ikft1h-indicatorContainer {
	color: #828a00 !important;
  }
  .css-8w2vus-indicatorContainer {
    color: #828a00 !important;
  }
  .css-17gwokl-indicatorContainer {
    color: #828a00 !important;
  }
  .css-1n7v3ny-option {
    background-color: #c3cd065e !important;
  }
  .MuiTypography-colorPrimary {
	color: #212322 !important;
    font-weight: bold !important;
  }
`;
